import NavBarItem from '@/src/components/nav-bar/nav-bar-item/NavBarItem'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@/src/analytics/amplitude'

type NavBarOption = 'my-hub' | 'my-team' | 'priorities'

const NavBar = () => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const handleNavItemClick = (item: NavBarOption) => {
    if (item === 'my-team') trackEvent('MY_TEAM_BUTTON_CLICK')
    if (item === 'priorities') trackEvent('PRIORITY_BUTTON_CLICK')
    void navigate(`/${item}`)
  }
  return (
    <nav className="border-t border-gray-200">
      <ul className="flex justify-center gap-3 bg-white">
        <li className="w-1/3">
          <NavBarItem
            data-testid="nav-bar-my-hub-button"
            label={t('pages.home.title')}
            icon="user"
            isActive={pathname.startsWith('/my-hub')}
            onButtonClick={() => handleNavItemClick('my-hub')}
          />
        </li>
        <li className="w-1/3">
          <NavBarItem
            data-testid="nav-bar-my-team-button"
            label={t('pages.my-team.title')}
            icon="group"
            isActive={pathname.startsWith('/my-team')}
            onButtonClick={() => handleNavItemClick('my-team')}
          />
        </li>
        <li className="w-1/3">
          <NavBarItem
            data-testid="nav-bar-priority-button"
            label={t('pages.priorities.title')}
            icon="thunderstorms"
            isActive={pathname.startsWith('/priorities')}
            onButtonClick={() => handleNavItemClick('priorities')}
          />
        </li>
      </ul>
    </nav>
  )
}

export default NavBar
